import type { Order } from "./orders";

export interface AdminStats {
  totalRevenue: number;
  totalOrders: number;
  totalProducts: number;
  totalCustomers: number;
  revenueGrowth: number;
  ordersGrowth: number;
  productsGrowth: number;
  customersGrowth: number;
}

export interface RevenueDataPoint {
  date: string;
  revenue: number;
  orders: number;
}

export interface AdminCustomer {
  id: string;
  name: string;
  email: string;
  phone: string;
  avatarUrl: string;
  joinDate: string;
  totalOrders: number;
  totalSpent: number;
  lastOrderDate: string | null;
  status: "active" | "inactive";
}

export const adminStats: AdminStats = {
  totalRevenue: 48729.45,
  totalOrders: 1254,
  totalProducts: 156,
  totalCustomers: 873,
  revenueGrowth: 12.5,
  ordersGrowth: 8.3,
  productsGrowth: 15,
  customersGrowth: 6.7,
};

export const revenueData: RevenueDataPoint[] = [
  { date: "Jan 01", revenue: 3200, orders: 87 },
  { date: "Jan 08", revenue: 4100, orders: 102 },
  { date: "Jan 15", revenue: 3800, orders: 95 },
  { date: "Jan 22", revenue: 2900, orders: 78 },
  { date: "Jan 29", revenue: 4500, orders: 115 },
  { date: "Feb 05", revenue: 5100, orders: 128 },
  { date: "Feb 12", revenue: 3900, orders: 99 },
  { date: "Feb 19", revenue: 4300, orders: 110 },
  { date: "Feb 26", revenue: 3700, orders: 92 },
  { date: "Mar 05", revenue: 5600, orders: 142 },
  { date: "Mar 12", revenue: 4800, orders: 121 },
  { date: "Mar 19", revenue: 5200, orders: 130 },
  { date: "Mar 26", revenue: 6100, orders: 155 },
  { date: "Apr 02", revenue: 4400, orders: 108 },
  { date: "Apr 09", revenue: 5800, orders: 148 },
  { date: "Apr 16", revenue: 6300, orders: 160 },
  { date: "Apr 23", revenue: 5500, orders: 138 },
  { date: "Apr 30", revenue: 7200, orders: 182 },
  { date: "May 07", revenue: 6800, orders: 170 },
  { date: "May 14", revenue: 5900, orders: 145 },
  { date: "May 21", revenue: 7100, orders: 178 },
  { date: "May 28", revenue: 6500, orders: 162 },
  { date: "Jun 04", revenue: 7800, orders: 195 },
  { date: "Jun 11", revenue: 7400, orders: 186 },
  { date: "Jun 18", revenue: 8100, orders: 202 },
];

export const adminCustomers: AdminCustomer[] = [
  {
    id: "cust-1",
    name: "Sarah Mitchell",
    email: "sarah.mitchell@email.com",
    phone: "+1 (555) 234-1001",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20with%20warm%20smile%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-sarah&orientation=squarish",
    joinDate: "2025-11-15",
    totalOrders: 24,
    totalSpent: 3847.50,
    lastOrderDate: "2026-06-20",
    status: "active",
  },
  {
    id: "cust-2",
    name: "James Rodriguez",
    email: "james.rodriguez@email.com",
    phone: "+1 (555) 234-1002",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20with%20confident%20expression%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-james&orientation=squarish",
    joinDate: "2025-12-03",
    totalOrders: 18,
    totalSpent: 2194.25,
    lastOrderDate: "2026-06-18",
    status: "active",
  },
  {
    id: "cust-3",
    name: "Aisha Rahman",
    email: "aisha.rahman@email.com",
    phone: "+1 (555) 234-1003",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20with%20friendly%20smile%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-aisha&orientation=squarish",
    joinDate: "2026-01-22",
    totalOrders: 9,
    totalSpent: 1240.80,
    lastOrderDate: "2026-06-15",
    status: "active",
  },
  {
    id: "cust-4",
    name: "David Kim",
    email: "david.kim@email.com",
    phone: "+1 (555) 234-1004",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20in%20his%2030s%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-david&orientation=squarish",
    joinDate: "2026-02-10",
    totalOrders: 12,
    totalSpent: 1876.40,
    lastOrderDate: "2026-06-19",
    status: "active",
  },
  {
    id: "cust-5",
    name: "Emma Wilson",
    email: "emma.wilson@email.com",
    phone: "+1 (555) 234-1005",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20with%20warm%20expression%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-emma&orientation=squarish",
    joinDate: "2026-03-05",
    totalOrders: 6,
    totalSpent: 830.45,
    lastOrderDate: "2026-06-10",
    status: "active",
  },
  {
    id: "cust-6",
    name: "Mike Torres",
    email: "mike.torres@email.com",
    phone: "+1 (555) 234-1006",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20with%20casual%20smile%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-mike&orientation=squarish",
    joinDate: "2026-03-18",
    totalOrders: 4,
    totalSpent: 512.75,
    lastOrderDate: "2026-05-28",
    status: "active",
  },
  {
    id: "cust-7",
    name: "Lisa Chang",
    email: "lisa.chang@email.com",
    phone: "+1 (555) 234-1007",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20in%20her%20late%2020s%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-lisa&orientation=squarish",
    joinDate: "2026-04-02",
    totalOrders: 7,
    totalSpent: 945.60,
    lastOrderDate: "2026-06-22",
    status: "active",
  },
  {
    id: "cust-8",
    name: "Robert Chen",
    email: "robert.chen@email.com",
    phone: "+1 (555) 234-1008",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20in%20his%2040s%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-robert&orientation=squarish",
    joinDate: "2026-04-15",
    totalOrders: 3,
    totalSpent: 389.90,
    lastOrderDate: "2026-06-05",
    status: "active",
  },
  {
    id: "cust-9",
    name: "Nadia Patel",
    email: "nadia.patel@email.com",
    phone: "+1 (555) 234-1009",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20with%20elegant%20look%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-nadia&orientation=squarish",
    joinDate: "2026-05-01",
    totalOrders: 2,
    totalSpent: 280.35,
    lastOrderDate: "2026-06-08",
    status: "active",
  },
  {
    id: "cust-10",
    name: "Tom Baker",
    email: "tom.baker@email.com",
    phone: "+1 (555) 234-1010",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20with%20friendly%20expression%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-tom&orientation=squarish",
    joinDate: "2026-05-20",
    totalOrders: 1,
    totalSpent: 89.99,
    lastOrderDate: "2026-06-01",
    status: "active",
  },
  {
    id: "cust-11",
    name: "Priya Kapoor",
    email: "priya.kapoor@email.com",
    phone: "+1 (555) 234-1011",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20woman%20with%20bright%20smile%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-priya&orientation=squarish",
    joinDate: "2025-10-05",
    totalOrders: 31,
    totalSpent: 5210.75,
    lastOrderDate: "2026-06-21",
    status: "active",
  },
  {
    id: "cust-12",
    name: "Omar Hassan",
    email: "omar.hassan@email.com",
    phone: "+1 (555) 234-1012",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20in%20his%2030s%20with%20warm%20look%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20corporate%20style&width=120&height=120&seq=admin-avatar-omar&orientation=squarish",
    joinDate: "2025-12-20",
    totalOrders: 15,
    totalSpent: 1920.30,
    lastOrderDate: "2026-05-30",
    status: "inactive",
  },
];

export function getCustomerOrders(customerId: string, allOrders: Order[]): Order[] {
  return allOrders.filter(() => {
    return customerId.length > 0;
  }).slice(0, Math.floor(Math.random() * 5) + 1);
}

export interface TopSellingProduct {
  id: string;
  name: string;
  category: string;
  imageUrl: string;
  unitsSold: number;
  revenue: number;
}

export interface CategoryBreakdown {
  name: string;
  revenue: number;
  percentage: number;
  colorClass: string;
}

export const topSellingProducts: TopSellingProduct[] = [
  {
    id: "prod-6",
    name: "Japanese Chef Knife Set",
    category: "Kitchen & Dining",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20Japanese%20chef%20knife%20set%20on%20wooden%20magnetic%20block%20on%20clean%20warm%20cream%20background%2C%20professional%20product%20photography%20front%20view&width=120&height=120&seq=top-knife&orientation=squarish",
    unitsSold: 142,
    revenue: 21299.58,
  },
  {
    id: "prod-14",
    name: "Cast Iron Dutch Oven",
    category: "Kitchen & Dining",
    imageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20enameled%20cast%20iron%20dutch%20oven%20in%20warm%20cream%20color%20on%20clean%20background%2C%20minimalist%20kitchen%20product%20photography%20with%20soft%20lighting&width=120&height=120&seq=top-oven&orientation=squarish",
    unitsSold: 98,
    revenue: 7839.02,
  },
  {
    id: "prod-1",
    name: "Wireless Headphones",
    category: "Electronics",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20wireless%20over-ear%20headphones%20in%20matte%20black%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20studio%20lighting%2C%20front%20view&width=120&height=120&seq=top-hp&orientation=squarish",
    unitsSold: 187,
    revenue: 15670.13,
  },
  {
    id: "prod-4",
    name: "Vitamin C Serum",
    category: "Beauty",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20vitamin%20C%20serum%20in%20amber%20glass%20bottle%20with%20dropper%20on%20clean%20warm%20cream%20background%2C%20luxury%20skincare%20product%20photography%20front%20view&width=120&height=120&seq=top-serum&orientation=squarish",
    unitsSold: 234,
    revenue: 8187.66,
  },
  {
    id: "prod-5",
    name: "Insulated Steel Bottle",
    category: "Sports & Outdoors",
    imageUrl: "https://readdy.ai/api/search-image?query=Sleek%20stainless%20steel%20insulated%20water%20bottle%20in%20matte%20black%20finish%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view&width=120&height=120&seq=top-bottle&orientation=squarish",
    unitsSold: 201,
    revenue: 5826.99,
  },
];

export const categoryBreakdown: CategoryBreakdown[] = [
  { name: "Kitchen & Dining", revenue: 29138.60, percentage: 23.8, colorClass: "bg-accent-500" },
  { name: "Electronics", revenue: 23784.45, percentage: 19.4, colorClass: "bg-primary-500" },
  { name: "Beauty", revenue: 18150.30, percentage: 14.8, colorClass: "bg-secondary-500" },
  { name: "Fashion", revenue: 16299.75, percentage: 13.3, colorClass: "bg-accent-400" },
  { name: "Home & Living", revenue: 15472.20, percentage: 12.6, colorClass: "bg-primary-400" },
  { name: "Sports & Outdoors", revenue: 13754.50, percentage: 11.2, colorClass: "bg-secondary-400" },
  { name: "Other", revenue: 6069.20, percentage: 4.9, colorClass: "bg-foreground-300" },
];

export interface AdminNotification {
  id: string;
  type: "order_placed" | "order_shipped" | "order_delivered" | "low_stock";
  title: string;
  description: string;
  time: string;
  read: boolean;
  linkTo: string;
}

export const adminNotifications: AdminNotification[] = [
  {
    id: "notif-1",
    type: "order_placed",
    title: "New order received",
    description: "Order GS-2026-10115 — $199.78 from Customer User",
    time: "2 min ago",
    read: false,
    linkTo: "/admin/orders/ord-003",
  },
  {
    id: "notif-2",
    type: "order_shipped",
    title: "Order shipped",
    description: "Order GS-2026-10089 shipped via Aramex",
    time: "18 min ago",
    read: false,
    linkTo: "/admin/orders/ord-002",
  },
  {
    id: "notif-3",
    type: "low_stock",
    title: "Low stock alert",
    description: "Japanese Chef Knife Set — only 25 remaining",
    time: "1 hour ago",
    read: false,
    linkTo: "/admin/products/prod-6/edit",
  },
  {
    id: "notif-4",
    type: "order_delivered",
    title: "Order delivered",
    description: "Order GS-2026-10042 delivered successfully",
    time: "3 hours ago",
    read: true,
    linkTo: "/admin/orders/ord-001",
  },
  {
    id: "notif-5",
    type: "low_stock",
    title: "Low stock alert",
    description: "Cast Iron Dutch Oven — only 30 remaining",
    time: "5 hours ago",
    read: true,
    linkTo: "/admin/products/prod-14/edit",
  },
  {
    id: "notif-6",
    type: "order_shipped",
    title: "Order shipped",
    description: "Order GS-2026-10042 shipped via DHL",
    time: "1 day ago",
    read: true,
    linkTo: "/admin/orders/ord-001",
  },
  {
    id: "notif-7",
    type: "order_placed",
    title: "New order received",
    description: "Order GS-2026-10089 — $56.14 from Customer User",
    time: "2 days ago",
    read: true,
    linkTo: "/admin/orders/ord-002",
  },
  {
    id: "notif-8",
    type: "low_stock",
    title: "Low stock alert",
    description: "Minimalist Leather Watch — only 35 remaining",
    time: "3 days ago",
    read: true,
    linkTo: "/admin/products/prod-2/edit",
  },
];